module.exports = __webpack_public_path__ + "img/GSK_bg_xl.0a0bf309.png";